import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Invokes a callback on the next effect, after the returned function has been called.
 *
 * For example, if you want to apply focus to an element only after some event occurs,
 * you can pass a callback to apply focus and invoke the function returned by
 * `useCallbackNextEffect` to trigger that callback on the next effect.
 *
 * Internally, the hook keeps a counter and its previous value. When the returned function
 * is called, it increments the count. Later, the effect is called. If the current count
 * is higher than the previous value, it will invoke the callback. Then, it will update
 * previous, so subsequent calls won't invoke the callback (until the returned function is
 * called again).
 */
export function useCallbackNextEffect(callback) {
    const [current, setCurrent] = useState(0);
    const previous = useRef(0);
    useEffect(() => {
        if (current !== previous.current) {
            callback();
        }
        previous.current = current;
    }, [callback, current, previous]);
    return useCallback(() => {
        setCurrent((v) => v + 1);
    }, []);
}
//# sourceMappingURL=useCallbackNextEffect.js.map